"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultStyle = {
  flexShrink: '0',
  fill: 'currentColor',
  userSelect: 'none',
  width: '1em'
};

var SvgIcon = function SvgIcon(props) {
  var children = props.children,
      _props$color = props.color,
      colorProp = _props$color === void 0 ? '#ADADAD' : _props$color,
      _props$display = props.display,
      displayProp = _props$display === void 0 ? 'inline-block' : _props$display,
      _props$fontSize = props.fontSize,
      fontSizeProp = _props$fontSize === void 0 ? '1.5rem' : _props$fontSize,
      _props$height = props.height,
      heightProp = _props$height === void 0 ? '1em' : _props$height,
      style = props.style,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      _props$width = props.width,
      widthProp = _props$width === void 0 ? '1em' : _props$width,
      _props$xmlns = props.xmlns,
      xmlns = _props$xmlns === void 0 ? 'http://www.w3.org/2000/svg' : _props$xmlns;
  return _react["default"].createElement(Svg, _extends({
    color: colorProp,
    display: displayProp,
    fontSize: fontSizeProp,
    height: heightProp,
    viewBox: viewBox,
    width: widthProp,
    xmlns: xmlns
  }, props, {
    style: _objectSpread({}, defaultStyle, {}, style)
  }), children, titleAccess && _react["default"].createElement("title", null, titleAccess));
};

exports.SvgIcon = SvgIcon;

var Svg = _styledComponents["default"].svg(_templateObject(), _styledSystem.alignContent, _styledSystem.alignItems, _styledSystem.alignSelf, _styledSystem.background, _styledSystem.backgroundColor, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.backgroundSize, _styledSystem.border, _styledSystem.borderColor, _styledSystem.boxShadow, _styledSystem.color, _styledSystem.display, _styledSystem.flex, _styledSystem.flexBasis, _styledSystem.flexDirection, _styledSystem.flexWrap, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontStyle, _styledSystem.fontWeight, _styledSystem.height, _styledSystem.justifyContent, _styledSystem.justifyItems, _styledSystem.justifySelf, _styledSystem.letterSpacing, _styledSystem.margin, _styledSystem.marginBottom, _styledSystem.marginLeft, _styledSystem.marginRight, _styledSystem.marginTop, _styledSystem.maxHeight, _styledSystem.maxWidth, _styledSystem.minHeight, _styledSystem.minWidth, _styledSystem.opacity, _styledSystem.overflow, _styledSystem.padding, _styledSystem.paddingBottom, _styledSystem.paddingLeft, _styledSystem.paddingRight, _styledSystem.paddingTop, _styledSystem.size, _styledSystem.space, _styledSystem.textAlign, _styledSystem.verticalAlign, _styledSystem.width, _styledSystem.zIndex);